require('./client.theme.config');

window.Vue = require('vue');
window.axios = require('axios');
window.moment = require('moment');
Vue.prototype.$bus = new Vue();

function loadMessages() {
    const context = require.context("./locales", true, /[a-z0-9-_]+\.json$/i);

    const messages = context
        .keys()
        .map((key) => ({ key, locale: key.match(/[a-z0-9-_]+/i)[0] }))
        .reduce(
            (messages, { key, locale }) => ({
                ...messages,
                [locale]: context(key),
            }),
            {}
        );

    return { context, messages };
}

// init sticky bottom bar
import initStickyBottomBar from "../sticky-bottom-bar";
initStickyBottomBar();

/** COMPONENTS */
//component
/*Vue.component('component', require('./components/component/Component.vue').default);*/
Vue.component('members', require('./components/wizard/first_phase/Members').default);
Vue.component('team', require('./components/wizard/first_phase/Team').default);
Vue.component('project-info', require('./components/wizard/first_phase/ProjectInfo').default);
Vue.component('other-info', require('./components/wizard/first_phase/OtherInfo').default);

Vue.component('members-second-phase', require('./components/wizard/second_phase/Members').default);
Vue.component('project-info-second-phase', require('./components/wizard/second_phase/ProjectInfo').default);
Vue.component('documentation', require('./components/wizard/second_phase/Documentation').default);
Vue.component('other-info-second-phase', require('./components/wizard/second_phase/OtherInfo').default);

Vue.component('custom-checkbox', require('../components/CustomCheckbox').default);
Vue.component('flash-toast', require('../components/FlashToast').default);

import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueI18n from 'vue-i18n';
import Toasted from 'vue-toasted';
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)
Vue.use(Vuelidate);
Vue.use(VueI18n);
Vue.use(Toasted, { position: 'bottom-center', duration: 5000 });

const { context, messages } = loadMessages();

const i18n = new VueI18n({
    locale: window.currentLocale ?? 'it',
    fallbackLocale: 'en',
    messages
})

const app = new Vue({
    i18n,
    el: '#app',
});


/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
